import script from "./AssessmentBeforeAfter.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentBeforeAfter.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentBeforeAfter.vue?vue&type=style&index=0&id=393ec787&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-393ec787"]])

export default __exports__